import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import { useSpring, animated, config } from 'react-spring'

export default function Rates() {

    const [flip, set] = useState(false)
    const fade = useSpring({
        to: { opacity: 1 },
        from: { opacity: 0 },
        delay: 200,
        config: config.molasses,
        onRest: () => set(!flip),
    })

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => setLoading(false), 300)
    }, [])

    return (
        <>
            {loading === false ? (
                <animated.div style={fade}>
                    <Container fluid>
                        <div className='greyHeader'>
                            <h1>Märzen - GSA Labor Catalog</h1>
                        </div>
                        <Container>
                            <Row className='paddingTop'>
                                <Col>
                                    <p>On 25 March 2020, Marzen Group LLC was awarded contract 47QTCA20D007V by the General Services Administration (GSA). This contract includes negotiated terms for labor rates that may be used by most agencies of the Federal Government. For information on the terms of Eligibility for the Use of GSA Sources of Supply and Services refer to GSA Order ADM 4800.2E.</p>
                                    <p>As part of contract 47QTCA20D007V Märzen Group LLC has established negotiated terms and conditions and competitive labor rates in the following general categories and established an Authorized MAS Schedule Pricelist. The negotiated rates provided are categorized into four engineering disciplines: Engineer, Systems Engineer, Data Link Engineer, and Test Engineer.</p>
                                    <p>The negotiated rates are for both works performed at the contractor site and government facilities.</p>
                                    <p>For additional information on Märzen Group labor rates - please contact us at: <a href='mailto:info@marzen.com'>info@marzen.com</a></p>
                                </Col>
                            </Row>                            
                        </Container>
                    </Container>
                </animated.div>
            ) : (
                <Spinner animation='border' role='status' className='spinner'>
                    <span className='invisible'>Loading...</span>
                </Spinner>
            )}
        </>
    )
}